import * as Immutable from 'immutable';

// reference: https://medium.com/trisfera/navigation-redirects-through-redux-middleware-1d2518695fd1
// Helper method for creating a middleware that handles the given set of actions

export default function createMiddleware(handlers) {
  return (storeAPI) => (next) => (action) => {
    const actionHandler = Immutable.List(handlers).find(
      (h) => h.action === action.type
    );

    // Execute custom middleware handler before the action is dispatched

    if (actionHandler && actionHandler.beforeHandler) {
      actionHandler.beforeHandler(storeAPI, action);
    }

    // Dispatch the action

    const result = next(action);

    // Execute custom middleware handler after the action is dispatched

    if (actionHandler && actionHandler.afterHandler) {
      actionHandler.afterHandler(storeAPI, action);
    }

    return result;
  };
}



// WEBPACK FOOTER //
// ./app/utils/middleware/middleware.js